"use strict";

/*
  Prepares and handles the image uploader element.
*/

require("jquery-confirm");
require("jquery-confirm/dist/jquery-confirm.min.css");

const $ = require("jquery");
const formStatus = require("./../booking-form-status/booking-form-status");
const axios = require("axios");

const BYPASS_STATIC_VALIDATION = true;

// returns the upload url for an image.
function getUploadUrl(identifier, baseRoute) {
  if (!identifier) throw Error("No identifier was given.");
  return baseRoute + "?identifier=" + identifier + "&type=image";
}

// returns the update url for an image.
function getUpdateUrl(id, baseRoute) {
  if (!id) throw new Error("No id given.");
  return baseRoute + "/" + id;
}

// returns the delete url for an image.
function getDeleteUrl(id, baseRoute) {
  if (!id) throw new Error("No id given.");
  return baseRoute + "/" + id;
}

// restore inner wrapper.
function removeLoadingClass(element) {
  $(element).removeClass("image-uploader__image-wrapper--loading");
}

// restore image element.
function onDeleteSuccess(element, data) {
  $(element).removeClass("image-uploader--can-delete");
  $(element).removeClass("image-uploader--can-edit");
  $(element).removeClass("image-uploader--has-image");

  $(element)
    .find("input[type=text]")
    .val("");
  $(
    $(element)
      .find("form")
      .get(0)
  ).attr("data-id", "null");
  formStatus.showSuccess("js-image-upload-section-form-status", data.success);
}

function onDeleteError(err) {
  formStatus.showError("js-image-upload-section-form-status", err);
}

// callback after the image was deleted.
function resetInputImage(element) {
  $(element).removeClass("js-image--changed");
}

// callback after the image is uploades.
function onUploadSuccess(element, data) {
  $(element).addClass("image-uploader--can-delete");
  $(element).addClass("image-uploader--can-edit");
  $(element).addClass("image-uploader--has-image");
  $(element).attr("data-id", data.mediaItem.id);
  $(element)
    .find("form")
    .attr("data-id", data.mediaItem.id);

  formStatus.showSuccess("js-image-upload-section-form-status", data.success);
}

// callback after image upload fail.
function onUploadError(err) {
  formStatus.showError("js-image-upload-section-form-status", err);
}

// show error if failed upload.
function showImageError(message) {
  let errorDiv = "";
  errorDiv +=
    '<div class="col-md-12 alert alert-warning alert-dismissible fade show" role="alert">';
  errorDiv += "<strong>Fehler: </strong> " + message + "";
  errorDiv +=
    '<button type="button" class="close" data-dismiss="alert" aria-label="Close">';
  errorDiv += '<span aria-hidden="true">&times;</span>';
  errorDiv += "</button>";
  errorDiv += "</div>";

  const alertdiv = jQuery.parseHTML(errorDiv)[0];
  $(".js-form-error").append(alertdiv);

  const timeOut = window.setTimeout(function() {
    window.clearTimeout(timeOut);
    $(alertdiv).alert("close");
  }, 5000);
}

// check the image dimensions.
function validateImageConstraints(image, imageElement, type, wrapper) {
  const img = new Image();
  img.src = image;

  img.onload = function() {
    function isPortrait(img) {
      return (
        (img.width == 720 && img.height == 1280) || BYPASS_STATIC_VALIDATION
      );
    }

    function isLandScape(img) {
      return (
        (img.width == 1280 && img.height == 720) || BYPASS_STATIC_VALIDATION
      );
    }

    function isSquare(img) {
      return img.height == img.width || BYPASS_STATIC_VALIDATION;
    }

    function isAny(img) {
      return (
        isPortrait(img) ||
        isLandScape(img) ||
        isSquare(img) ||
        BYPASS_STATIC_VALIDATION
      );
    }

    function validate(imageElement, image) {
      $(imageElement).attr("src", image);
    }

    function invalidateImage(wrapper, msg) {
      $(wrapper)
        .find("input[type=file]")
        .val("");
      showImageError(msg);
    }

    if (type == "portrait") {
      if (isPortrait(img)) {
        validate(imageElement, image);
        return true;
      } else {
        invalidateImage(wrapper, "The image should be 720x1280");
      }
    } else if (type == "landscape") {
      if (isLandScape(img)) {
        validate(imageElement, image);
        return true;
      } else {
        invalidateImage(wrapper, "The image should be 1280x720");
      }
    } else if (type == "square") {
      if (isSquare(img)) {
        validate(imageElement, image);
        return true;
      } else {
        invalidateImage(wrapper, "The image should be square.");
      }
    } else if (type == "any") {
      validate(imageElement, image);
      return true;
    } else {
      if (isAny(img)) {
        validate(imageElement, image);
        return true;
      } else {
        invalidateImage(wrapper, "The image should be 1280x720 or 720x1280.");
      }
    }

    return false;
  };
}

function setImageuploaderToEditMode(wrapper) {
  $(wrapper).addClass("js-image--changed");
  $(wrapper).addClass("image-uploader--has-image");
  $(wrapper).addClass("image-uploader--can-edit");
  $(wrapper).removeClass("image-uploader--can-delete");
}

// callback when the image input is set up.
function imageLoaded(event, element, imageElement, wrapper, type) {
  setImageuploaderToEditMode(wrapper);
  const fileReader = new FileReader();
  fileReader.readAsDataURL(element.files[0]);

  fileReader.onload = function(e) {
    validateImageConstraints(e.target.result, imageElement, type, wrapper);
  };
}

// perform the actual request.
function makeRequest(url, formData, method, wrapper) {
  $(".js-image-uploader-submit").removeClass("button--orange");
  $(".js-image-uploader-submit").attr("disabled", true);

  const innerWrapper = $(wrapper).find(".image-uploader__image-wrapper");
  $(innerWrapper).addClass("image-uploader__image-wrapper--loading");

  axios
    .post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
        cache: false
      }
    })
    .then(function(result) {
      if (method == "POST") {
        onUploadSuccess(wrapper, result.data);
      } else if (method == "PUT") {
        onUploadSuccess(wrapper, result.data);
      } else if (method == "DELETE") {
        onDeleteSuccess(wrapper, result.data);
      }

      removeLoadingClass(innerWrapper);
      resetInputImage(wrapper);
      $(".js-image-uploader-submit").addClass("button--orange");
      $(".js-image-uploader-submit").attr("disabled", false);
    })
    .catch(function(err) {
      let errorMessage;
      try {
        for (let attribute in err.response.data.errors) {
          let errorsForAttribute = err.response.data.errors[attribute];
          errorMessage = errorsForAttribute[0];
        }
      } catch (e) {
        errorMessage = err.response.data.message;
      }
      if (method == "DELETE") {
        onDeleteError(errorMessage);
      } else {
        onUploadError(errorMessage);
      }

      removeLoadingClass(innerWrapper);
      $(".js-image-uploader-submit").addClass("button--orange");
      $(".js-image-uploader-submit").attr("disabled", false);
    });
}

// find out what images should be uyploaded.
function uploadImages() {
  formStatus.clearStatus("js-image-upload-section-form-status");

  $(".js-image--changed").each(function(i, element) {
    const form = $(element)
      .find("form")
      .get(0);

    const id = $(form).attr("data-id");
    const identifier = $(form).attr("data-identifier");
    const updatingImage = id !== "" && !isNaN(Number(id));
    const baseRoute = $(form).attr("data-base-route");

    const targetUrl = updatingImage
      ? getUpdateUrl(id, baseRoute)
      : getUploadUrl(identifier, baseRoute);

    const method = updatingImage ? "PUT" : "POST";

    const doNotUploadImage = !$(element).hasClass("js-image--changed");

    const formData = new FormData(form);
    if (doNotUploadImage) {
      formData.delete("value");
    }

    formData.append("_method", method);

    const cropedCanvas = $(element)
      .find(".js-canvas-wrapper canvas")
      .get(0);

    cropedCanvas.toBlob(function(blob) {
      formData.append("value", blob);
      makeRequest(targetUrl, formData, method, element);
    });
  });
}

//  set up the delete button.
function deleteImage(element) {
  // const target = $(element).data("target");

  $.confirm({
    title: "Löschen bestätigen",
    content: "Willst du die Medien Datei wirklich löschen?",
    draggable: false,
    backgroundDismiss: true,
    buttons: {
      cancel: {
        text: "Abbrechen",
        action: function() {}
      },
      confirm: {
        text: "Löschen",
        btnClass: "button button--orange",
        action: function() {
          const form = $(element)
            .find("form")
            .get(0);

          const id = $(form).attr("data-id");
          const baseRoute = $(form).attr("data-base-route");
          const targetUrl = getDeleteUrl(id, baseRoute);

          const formData = new FormData(form);
          formData.append("_method", "DELETE");
          makeRequest(targetUrl, formData, "DELETE", element);
        }
      }
    }
  });
}

function onLoad() {
  // Prepare the images
  $(".js-image-uploader").each(function(_, element) {
    const fileInputElement = $(element)
      .find("input[type=file]")
      .get(0);

    const textInputElement = $(element)
      .find("input[type=text]")
      .get(0);

    const imageElement = $(element).find(".js-image-uploader-target");
    const deleteButton = $(element)
      .find(".js-image-delete ")
      .get(0);

    const type = $(element).data("type");

    $(fileInputElement).on("change", function(e) {
      imageLoaded(e, this, imageElement, element, type);
      uploadImages();
    });

    $(textInputElement).on("change", function(e) {
      $(element).addClass("js-image--changed");
      $(element).addClass("js-image--caption-changed");
    });

    $(deleteButton).on("click", function() {
      formStatus.clearStatus("js-image-upload-section-form-status");
      deleteImage(element);
    });

    $(element)
      .find("form")
      .on("keyup keypress", function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
          e.preventDefault();
          return false;
        }
      });
  });
}

if (process.env.NODE_ENV === "test") {
  module.exports = {
    getUploadUrl,
    getUpdateUrl,
    getDeleteUrl,
    removeLoadingClass,
    onDeleteSuccess,
    resetInputImage,
    onUploadSuccess,
    showImageError,
    validateImageConstraints,
    imageLoaded,
    makeRequest,
    uploadImages,
    deleteImage,
    onLoad
  };
} else {
  module.exports = {
    onLoad,
    uploadImages,
    validateImageConstraints,
    setImageuploaderToEditMode
  };
}



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-image-uploader/booking-image-uploader.js